// Google Analytics 4 utility functions

export const trackEvent = (eventName, parameters = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, parameters);
  }
};

// Track CTA button clicks
export const trackCTAClick = (ctaName, location) => {
  trackEvent('cta_click', {
    cta_name: ctaName,
    location: location
  });
};

// Track page views (for SPA navigation)
export const trackPageView = (pagePath, pageTitle) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-WET7PZPQD8', {
      page_path: pagePath,
      page_title: pageTitle
    });
  }
};

// Track newsletter signup
export const trackNewsletterSignup = (location) => {
  trackEvent('newsletter_signup', {
    location: location
  });
};

// Track product view
export const trackProductView = (productName, productPrice) => {
  trackEvent('view_item', {
    item_name: productName,
    price: productPrice
  });
};

// Track external link clicks
export const trackExternalLink = (url, linkName) => {
  trackEvent('external_link_click', {
    link_url: url,
    link_name: linkName
  });
};
